var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$apollo.loading)?_c('div',[_c('spinner')],1):_c('div',[(_vm.status === 'SUCCESSFUL')?_c('span',[_vm._v(_vm._s(_vm.$t('paymentDone', 'The payment has already been made')))]):_c('span',[_vm._v("\n      "+_vm._s(_vm.$t('paymentCanceled'))+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }